import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, ServicioGrupo, SearchServicioGrupoRequest, SearchServicioGrupoResponse, SaveServicioGrupoDto } from "../model/index";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})
export class ServicioGrupoService extends CrudService<ServicioGrupo, number, SaveServicioGrupoDto, SearchServicioGrupoRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'servicioGrupo', sharedFunctions);

  }
}